module.exports = "/_next/static/images/UseSegment@2x-4e2e7f39ebb750dbc52458ac8a466a3a.webp";